import { Graphics } from '@pixi/react';
import { tileWidth, tileHeight } from '../../data/tileset.config';

export default ({
  x,
  y,
  zIndex,
  anchor,
  width = tileWidth,
  height = tileHeight,
}: {
  x: number;
  y: number;
  zIndex: number;
  anchor: [number, number];
  width?: number;
  height?: number;
}) => {
  return (
    <>
      <Graphics
        position={[x, y]}
        zIndex={zIndex}
        anchor={anchor}
        draw={(g: any) => {
          g.clear();
          g.beginFill(0x8b00ff);
          g.drawRect(-width / 2, -height / 2, width, height);
          g.endFill();
        }}
      />
    </>
  );
};
